import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void) {
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
}

/** `false`, пока вкладка скрыта (свёрнута или открыта другая вкладка). */
export function useIsDocumentVisible(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => document.visibilityState === "visible",
        () => true,
    );
}
